/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordStockIntakeFieldComponent } from '../../admin/form/form-record/fields/stock-intake/form-record-stock-intake-field.component';
/* eslint-enable */

export class FormRecordStockIntakeFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordStockIntakeFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
